import * as envVars from '@/library/env-vars';

export const recaptchaPublicKey = envVars.getEnvVar('recaptchaPublicKey');
export const desactivarPago = envVars.getEnvVar('desactivarPago');
export const autocontratarApiName = 'autocontratarApi';
export const ambienteNoProductivo = envVars.getEnvVar('ambienteNoProductivo');
export const intervaloChequeoVersion = 5; // Minutos